import styled, { css } from 'styled-components';
import { themeColor } from '../../theme/colors';
import { mdBold, xxxsRegular } from '../../theme/typography';
import { Button } from '../../Button/Button';

export const Container = styled.div``;

export const Title = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

export const ReferenceChartContainer = styled.div<{ sticky?: boolean }>`
  width: fit-content;
  display: flex;
  /* background: red; */
  /* transform: translateY(14px); */
  ${({ sticky }) =>
    sticky &&
    css`
      position: sticky;
      top: 35px;
      z-index: 1;
      pointer-events: none;
    `}
`;

export const SingleChartContainer = styled.div`
  width: fit-content;
  display: flex;

  &:not(:last-of-type) {
    border-bottom: 1px ${themeColor('strokeLight')} solid;
  }
`;

export const SingleChartHeader = styled.div<{
  width: string | number;
}>`
  --header-width: ${({ width }) => {
    if (typeof width === 'number') return `${width}px`;
    return width;
  }};
  min-width: var(--header-width);
  max-width: var(--header-width);
  flex: 1;
  padding-top: 12px;

  display: flex;
  flex-direction: column;
  gap: 10px;

  color: ${themeColor('textPrimary')};

  ${mdBold}
`;

export const SingleChartBody = styled.div`
  .yAxis {
    user-select: none;
  } 
  flex: 1;
`;

export const ChartSkeleton = styled.div`
  display: flex;
  align-items: center;
  opacity: 0.3;
`;

export const TooltipContainer = styled.div`
  ${xxxsRegular}
  border-radius: 6px;
  background: ${themeColor('turquoiseQuaternary')};
  padding: 4px 5px;
  color: ${themeColor('turquoise')};

  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const TooltipEntry = styled.div<{ color?: string }>`
  display: flex;
  gap: 4px;
  align-items: center;
  color: ${({ color }) => color || themeColor('turquoise')};
`;

export const Dot = styled.div<{ color?: string; size?: number }>`
  background: ${({ color }) => color || themeColor('turquoise')};
  width: ${({ size }) => size || 10}px;
  height: ${({ size }) => size || 10}px;
  border-radius: 100%;
`;

export const FilterButton = styled(Button).attrs({ size: 'xs' })`
  padding: 2.5px;
`;
